'use client';

import { c as _c } from "react/compiler-runtime";
import { useAtomValue } from 'jotai';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { currentCurrencyAtom } from '@/features/currency/atoms/currencies-atom';
import getBudgetFilterValues from '@/features/currency/requests/get-budget-filter-values';
import ListingFilterNew from '@/features/listing/components/listings-filters/listing-filter-new/listing-filter-new';
import { LISTINGS_BUDGET_FILTER } from '@/features/listing/constants/listings-filters-constants';
import { type ListingsFilterName, type ListingsRangeFilter, PaginationNames } from '@/features/listing/types/listing-filters-types';
import { useRouter } from '@/i18n/routing';
import ListingFilterRange from '../listing-filter-range/listing-filter-range';
interface ListingBudgetFilterProps {
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
  setFilterLink: (link: {
    pathname: string;
    searchParams: URLSearchParams;
  }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
}
export default function ListingBudgetFilter(props) {
  const $ = _c(43);
  const {
    filterLink,
    onFilterDisplayChange,
    setFilterLink
  } = props;
  const currency = useAtomValue(currentCurrencyAtom);
  const searchParams = useSearchParams();
  const router = useRouter();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(LISTINGS_BUDGET_FILTER.options.min.name);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const budgetMinValue = Number(t0);
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get(LISTINGS_BUDGET_FILTER.options.max.name);
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const budgetMaxValue = Number(t1);
  const [budgetFilter, setBudgetFilter] = useState(LISTINGS_BUDGET_FILTER);
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const translationsFilterBudget = useTranslations("listing.filters.budget");
  const budgetButtonTitleMin = budgetMinValue || budgetFilter.options.min.defaultValue;
  const budgetButtonTitleMax = budgetMaxValue || budgetFilter.options.max.defaultValue;
  let t2;
  if ($[4] !== budgetButtonTitleMax || $[5] !== budgetButtonTitleMin || $[6] !== budgetMaxValue || $[7] !== budgetMinValue || $[8] !== translationsFilterBudget) {
    t2 = budgetMinValue || budgetMaxValue ? `${String(budgetButtonTitleMin)} - ${String(budgetButtonTitleMax)}` : translationsFilterBudget("button");
    $[4] = budgetButtonTitleMax;
    $[5] = budgetButtonTitleMin;
    $[6] = budgetMaxValue;
    $[7] = budgetMinValue;
    $[8] = translationsFilterBudget;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const budgetButtonTitle = t2;
  let t3;
  if ($[10] !== budgetFilter || $[11] !== filterLink.pathname || $[12] !== filterLink.searchParams || $[13] !== setFilterLink) {
    t3 = () => {
      filterLink.searchParams.delete(budgetFilter.options.min.name);
      filterLink.searchParams.delete(budgetFilter.options.max.name);
      const newValue = {
        ...budgetFilter
      };
      newValue.options.max.value = budgetFilter.options.max.defaultValue;
      newValue.options.min.value = budgetFilter.options.min.defaultValue;
      setBudgetFilter(newValue);
      setFilterLink({
        pathname: filterLink.pathname,
        searchParams: filterLink.searchParams
      });
    };
    $[10] = budgetFilter;
    $[11] = filterLink.pathname;
    $[12] = filterLink.searchParams;
    $[13] = setFilterLink;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const handleClear = t3;
  let t4;
  if ($[15] !== setFilterLink) {
    t4 = updatedFilterLink => {
      if (updatedFilterLink.searchParams.has(PaginationNames.PageNumber)) {
        updatedFilterLink.searchParams.delete(PaginationNames.PageNumber);
      }
      setFilterLink(updatedFilterLink);
    };
    $[15] = setFilterLink;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleChangeFilterLink = t4;
  let t5;
  if ($[17] !== filterLink.pathname || $[18] !== filterLink.searchParams || $[19] !== router) {
    t5 = () => {
      router.push(`${filterLink.pathname}?${filterLink.searchParams.toString()}`);
    };
    $[17] = filterLink.pathname;
    $[18] = filterLink.searchParams;
    $[19] = router;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const handleApplyClick = t5;
  let t6;
  if ($[21] !== budgetButtonTitleMax || $[22] !== budgetButtonTitleMin || $[23] !== currency.name) {
    t6 = () => {
      const cloneFilter = JSON.stringify(LISTINGS_BUDGET_FILTER);
      const updatedFilter = JSON.parse(cloneFilter) as ListingsRangeFilter;
      getBudgetFilterValues(currency.name).then(values => {
        updatedFilter.options.max.defaultValue = values.max;
        updatedFilter.options.max.value = budgetButtonTitleMax;
        updatedFilter.options.min.defaultValue = values.min;
        updatedFilter.options.min.value = budgetButtonTitleMin;
        setBudgetFilter(updatedFilter);
      }).catch(_temp);
    };
    $[21] = budgetButtonTitleMax;
    $[22] = budgetButtonTitleMin;
    $[23] = currency.name;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== budgetButtonTitleMax || $[26] !== budgetButtonTitleMin || $[27] !== currency) {
    t7 = [currency, budgetButtonTitleMax, budgetButtonTitleMin];
    $[25] = budgetButtonTitleMax;
    $[26] = budgetButtonTitleMin;
    $[27] = currency;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  useEffect(t6, t7);
  let t8;
  if ($[29] !== translationsFilterBudget) {
    t8 = translationsFilterBudget("dropdown-title");
    $[29] = translationsFilterBudget;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== budgetFilter || $[32] !== filterLink || $[33] !== handleChangeFilterLink) {
    t9 = <ListingFilterRange filterLink={filterLink} filter={budgetFilter} setFilterLink={handleChangeFilterLink} />;
    $[31] = budgetFilter;
    $[32] = filterLink;
    $[33] = handleChangeFilterLink;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== budgetButtonTitle || $[36] !== handleApplyClick || $[37] !== handleClear || $[38] !== isPopoverOpen || $[39] !== onFilterDisplayChange || $[40] !== t8 || $[41] !== t9) {
    t10 = <ListingFilterNew buttonText={budgetButtonTitle} dialogTitle={t8} onFilterDisplayChange={onFilterDisplayChange} listingFilterName="listingsBudget" isPopoverOpen={isPopoverOpen} setPopoverOpen={setPopoverOpen} onClear={handleClear} onApplyClick={handleApplyClick}>{t9}</ListingFilterNew>;
    $[35] = budgetButtonTitle;
    $[36] = handleApplyClick;
    $[37] = handleClear;
    $[38] = isPopoverOpen;
    $[39] = onFilterDisplayChange;
    $[40] = t8;
    $[41] = t9;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  return t10;
}
function _temp() {
  return null;
}